import React, { useEffect, useState } from "react";
import { bullHornCallBack } from "./utils";

const BullHornCallback = () => {
  const [code, setCode] = useState(null);
  const [codeError, setCodeError] = useState(false);
  useEffect(() => {
    const generateToken = async (code) => {
      const status = await bullHornCallBack(code);
      if (status.error && status.error === true){
        setCodeError(true);
      }
    };
    // Get the current URL's search params (everything after the '?')
    const queryParams = new URLSearchParams(window.location.search);

    // Get the 'page' parameter
    const code = queryParams.get("code");
    if (code) {
      generateToken(code);
    }
  }, []);

  return (
    <>
      <div className="w-full m-auto text-center">
        <h4 className="font-bold mt-20">
          {codeError
            ? `Authentication with Bullhorn failed. Please try again.`
            : "Bullhorn authentication was successful. The system will begin fetching jobs and candidates from Bullhorn in the background."}
        </h4>
      </div>
    </>
  );
};

export default BullHornCallback;
